import * as React from "react"
import { useRef, useState } from "react"
import { css } from "@emotion/react"
import VisibilitySensor from "react-visibility-sensor"
import { useAccosEffect } from "./accos-effect"
import { useActivitiesEffect } from "./activities-effect"
import { useRailwayStationsEffect } from "./railwaystations-effect"
import { useDistanceMarkerEffect } from "./distance-marker-effect"
import "../../styles/maps/map.scss"
import * as L from "leaflet"
import "leaflet.markercluster"
import "leaflet-fullscreen"
import { IBookingHotel } from "../../shared-interfaces/booking-hotel"
import { IActivity } from "../../shared-interfaces/activity"
import { IRailwayStation } from "../../shared-interfaces/railway-station"
import { KmGroups } from "../../shared-interfaces/km.groups"
import { IHop } from "../../shared-interfaces/hop"


const mapboxToken = "pk.eyJ1IjoibXNlZW1hbm4iLCJhIjoiY2p3NHlkdWpiMDhqZzQzcGIycThqb2tydyJ9.XGbytj3C8qSuWbLGVuW2UA"

type Props = {
  track: GeoJSON.FeatureCollection<GeoJSON.GeometryObject>;
  accos: IBookingHotel[] | null;
  showPrice?: boolean;
  activities?: IActivity[] | null;
  stations?: IRailwayStation[] | null;
  hops: IHop[];
  tourSlug: string;
  kilometerMarkerCoords: number[][]
}

const Map = ({ track, accos, showPrice = false, activities = null, stations = null, hops, tourSlug, kilometerMarkerCoords }: Props) => {

  const overviewMap = useRef<HTMLDivElement>(null)
  const map = useRef<L.Map | null>(null)
  const kmGroups = useRef<KmGroups | null>(null)
  const [mapVisible, setMapVisible] = useState<boolean>(false)

  useAccosEffect(accos, mapVisible, showPrice, map, track.features[0].properties.name, tourSlug)
  useActivitiesEffect(activities, mapVisible, showPrice, map)
  useRailwayStationsEffect(stations, mapVisible, map)
  useDistanceMarkerEffect(kilometerMarkerCoords, mapVisible, map, kmGroups)

  const onVisibilityChange = (visible: boolean) => {

    if (visible && L && !map.current) {

      kmGroups.current = {
        kmLayerGroup5: L.layerGroup(),
        kmLayerGroup10: L.layerGroup(),
        kmLayerGroup50: L.layerGroup(),
      }

      map.current = L.map(overviewMap.current!.id, { fullscreenControl: true })
      map.current.setMaxZoom(19)

      //
      // L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      //   attribution: "&copy; <a href=\"https://www.openstreetmap.org/copyright\">OpenStreetMap</a> contributors",
      // }).addTo(map.current)

      import("mapbox-gl-leaflet").then(() => {
        L.mapboxGL({
          accessToken: mapboxToken,
          style: "mapbox://styles/mapbox/outdoors-v11",
        }).addTo(map.current!)
      })

      const geoJson = L.geoJSON(track as any)
      geoJson.addTo(map.current)
      map.current.fitBounds(geoJson.getBounds())

      hops.forEach(hop => {
        const circle = L.circle([hop.lngLat[1], hop.lngLat[0]], {
          color: "#ff9800",
          radius: 500,
        }).addTo(map.current!)
        circle.bindPopup(hop.name)
      })

      setMapVisible(visible)
    }
  }

  return (
    <VisibilitySensor onChange={onVisibilityChange} partialVisibility={true}>
      <div>
        <div css={
          css`
          position: relative;
          width: 100%;
          padding-bottom: 62%;
          height: 0;
          margin: 0;
          @media screen and (max-width: 769px) {
            padding-bottom: 130%;
          }
        `
        }>
          <div ref={overviewMap} id="overviewMap"/>
        </div>
      </div>
    </VisibilitySensor>
  )
}

export default Map
